import React, { useEffect, useRef, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import '../../css/editor.css';
import ApiService from '../../../../services/api'
import { toast } from "react-toastify";
import Save from '../../../../media/save.png';
import Delete from '../../../../media/delete.png';
import settings from '../../../../media/settings_b.png';
import QuillEditor from '../../../../services/quill_editor';
import TinyMCEEditor from '../../../../services/tinymce';



const Settings = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [form, setForm] = useState({
    privacy_policy: '',
    legal_notes: '',
    cookie_policy: '',
   
  });

  const [errors, setErrors] = useState({});

  
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await ApiService.getLegal();

        setForm({
          privacy_policy: res.privacy_policy || '',
          legal_notes: res.legal_notes|| '',
          cookie_policy: res.cookie_policy || '',
        });

      } catch (err) {
        console.error('Errore nel caricamento:', err);
        toast.error('Errore nel caricamento dei dati');
        navigate('/admin'); 
      }
    };

    fetchSettings();
  }, [navigate]);

  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

const handleQuillChange = (field) => (html) => {
    setForm((prev) => ({ ...prev, [field]: html }));
};

  const isEmptyQuill = (html) => {
  if (!html) return true;

  const div = document.createElement("div");
  div.innerHTML = html;

  const text = (div.textContent || '')
    .replace(/\u200B/g, '')
    .trim();

  return text.length === 0;
};


  

  const validate = () => {
  const errs = {};

  if (isEmptyQuill(form.privacy_policy)) {
    errs.privacy_policy = ["Privacy Policy obbligatoria", true];
  }

  if (isEmptyQuill(form.legal_notes)) {
    errs.legal_notes = ["Note Legali obbligatorie", true];
  }

  if (isEmptyQuill(form.cookie_policy)) {
    errs.cookie_policy = ["Cookie Policy obbligatoria", true];
  }

  return errs;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    

    try {
      setSaving(true);
      await ApiService.updateLegal(form);
      toast.success('Impostazioni salvate con successo');
      navigate('/admin');
    } catch (err) {
      console.error(err);
      toast.error('Errore durante l\'aggiornamento');
    }
    finally {
      setSaving(false);
    }
  };



  return (
    <form className="editor-form" onSubmit={handleSubmit}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2><img src={settings} alt="" className="section-image" />Impostazioni</h2>
      </div>

      <label>Privacy Policy</label>
      <div className={errors.privacy_policy ? "error" : ""}>
      <TinyMCEEditor
        value={form.privacy_policy}
        onChange={handleQuillChange('privacy_policy')}
        
      />
      {errors.privacy_policy && <span className='error'>{errors.privacy_policy}</span>}
      </div>

      <label>Note Legali</label>
      <div className={errors.legal_notes ? "error" : ""}>
      <TinyMCEEditor
        value={form.legal_notes}
        onChange={handleQuillChange('legal_notes')}
      />
      {errors.legal_notes && <span className='error'>{errors.legal_notes}</span>}
      </div>

      <label>Cookie Policy</label>
      <div className={errors.cookie_policy ? "error" : ""}>
        <TinyMCEEditor
          value={form.cookie_policy}
          onChange={handleQuillChange('cookie_policy')}
        />
      {errors.cookie_policy && <span className='error'>{errors.cookie_policy}</span>}
      </div>

      <button type="submit"  disabled={saving || deleting} style={{ backgroundColor: '#2ecc71', marginTop: "50px" }}>
        <img src={Save} alt="Salva" className="button-image2" />
        {saving ? 'Salvataggio in corso...' : 'Salva'}
      </button>
    </form>
  );
};

export default Settings;
